<a
  *ngIf="!!href"
  [attr.href]="href"
  class="h-100 w-100 p-absolute c-pointer"
></a>

<img class="pe-none" [style.vertical-align]="verticalAlign" [src]="iconSrc" />
